// extracted by mini-css-extract-plugin
module.exports = {"buttons":"thcYpl","button":"_1pcodP","shine-lines":"_2LqwTJ"};